<template>
    <div class="min-h-screen bg-background">
        <LandingHeader :chrome="chrome" />

        <template v-for="(block, i) in blocks" :key="i">
            <component :is="resolve(block.type)" v-if="resolve(block.type)" :content="block.content || {}" />
        </template>

        <LandingFooter :chrome="chrome" />
    </div>
</template>

<script>
import LandingHeader from "../blocks/Header.vue";
import LandingFooter from "../blocks/Footer.vue";
import { resolveBlock } from "../blocks/registry.js";

export default {
    name: "LandingApp",
    components: { LandingHeader, LandingFooter },
    props: {
        state: { type: Object, default: () => ({}) },
    },
    provide() {
        return {
            // доменные настройки формы входа (вкладки) — для блока auth
            landingAuth: this.state.auth || {},
            // тексты согласия на обработку ПД из настроек домена — для блоков cta и auth
            landingConsent: this.state.consent || {},
            landingPreview: false,
        };
    },
    computed: {
        blocks() {
            return this.state.blocks || [];
        },
        chrome() {
            return this.state.chrome || {};
        },
    },
    methods: {
        resolve(type) {
            return resolveBlock(type);
        },
    },
};
</script>
